import { stillSuccessUrlList } from "@/config";
import { AxiosResponse } from "axios";
import { LoggerInfoTag, postLogInfo } from "../api/log";
import AuthTokenHolder from "./AuthTokenHolder";
import {
    getIsShowErrorModal,
    showErrorModal,
    showLargeFileErrorModal,
    showLoginExpiryModal,
    showNetworkErrorModal,
} from "./utils";
import { parse as urlParse } from "url";

/**
 * 授权过期
 */
function authInvalidResponseHandler(error) {
    AuthTokenHolder.clearToken();

    showLoginExpiryModal();

    return Promise.reject(error);
}

/**
 * 最后默认兜底的错误处理方式
 */
function defaultResponseHandler(error) {
    console.error(error);
    console.log(error.config);

    const errorMessage = error?.message || "请检查您的网络设置，请求发送失败！";
    const requestUrl = error?.config?.url || "";

    const urlParsed = urlParse(requestUrl);

    const isStillSuccess = stillSuccessUrlList.some((url) => urlParsed.path === url);

    if (isStillSuccess) {
        return Promise.resolve();
    }

    const isShowErrorModal = getIsShowErrorModal(requestUrl);

    // 如果有超时的请求
    if (errorMessage?.includes("ms exceeded") && !requestUrl?.includes("/frontend_logger/info")) {
        let paramsString = "";
        let bodyString = "";

        try {
            paramsString = JSON.stringify(error?.config?.params);
            bodyString = JSON.stringify(error?.config?.data);
        } catch (error) {}

        // 超时发送日志回系统
        postLogInfo({
            tag: LoggerInfoTag.REQUEST_TIMEOUT,
            content: `request timeout method: ${error?.config?.method}, path:${requestUrl}, server:${error?.config?.baseURL}, params data: ${paramsString}, body data: ${bodyString}`,
        });
    }

    // 网络请求错误
    if (errorMessage?.includes("Network Error") && !requestUrl?.includes("/frontend_logger/info")) {
        let paramsString = "";
        let bodyString = "";

        try {
            paramsString = JSON.stringify(error?.config?.params);
            bodyString = JSON.stringify(error?.config?.data);
        } catch (error) {}

        // 请求错误发送日志回系统
        postLogInfo({
            tag: LoggerInfoTag.REQUEST_NETWORK_ERROR,
            content: `request network error: ${error?.config?.method}, path:${requestUrl}, server:${error?.config?.baseURL}, params data: ${paramsString}, body data: ${bodyString}`,
        });
    }

    if (error?.config?.hideModal) {
        return Promise.reject(new Error(errorMessage));
    }

    if (isShowErrorModal) {
        showNetworkErrorModal("网络请求错误", error);
    }

    return Promise.reject(error);
}

/**
 * 未拿到数据的情况，先从响应的状态码判断，最后走兜底
 */
export default function responseRejectedHandler(error) {
    const response = error?.response as AxiosResponse;

    const statusCode = response?.status;

    switch (statusCode) {
        // 权限校验失败状态
        case 401:
        case 403:
            return authInvalidResponseHandler(error);
        case 413:
            return showLargeFileErrorModal();
        // 权限校验失败状态
        default:
            return defaultResponseHandler(error);
    }
}
